import * as React from 'react';

function SvgPaypalColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 58 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.791 10.725h-2.468a.337.337 0 00-.34.27l-.998 5.907c-.02.116.077.221.204.221h1.179a.337.337 0 00.338-.27l.27-1.593a.336.336 0 01.338-.27h.782c1.626 0 2.564-.735 2.81-2.19.11-.636.004-1.137-.315-1.487-.351-.385-.974-.588-1.8-.588zm.285 2.157c-.135.827-.812.827-1.466.827h-.372l.26-1.544a.202.202 0 01.204-.162h.17c.447 0 .867 0 1.084.237.13.142.17.352.12.642zM30.17 12.856h-1.183c-.1 0-.187.068-.203.162l-.052.308-.083-.112c-.256-.346-.826-.462-1.396-.462a2.659 2.659 0 00-2.64 2.218c-.112.646.049 1.264.441 1.695.36.396.876.56 1.49.56 1.052 0 1.635-.63 1.635-.63l-.052.306c-.02.117.077.222.203.222h1.064c.17 0 .313-.115.34-.27l.638-3.776c.02-.116-.076-.221-.202-.221zm-1.648 2.146c-.114.63-.65 1.053-1.334 1.053-.343 0-.617-.102-.793-.297-.175-.193-.242-.468-.186-.775.107-.625.652-1.061 1.325-1.061.335 0 .608.104.788.3.18.198.252.475.2.78zM36.465 12.856h-1.188a.351.351 0 00-.284.14l-1.638 2.252-.695-2.164a.342.342 0 00-.329-.228h-1.167c-.142 0-.24.129-.195.254l1.308 3.582-1.23 1.62c-.097.128 0 .304.168.304H32.4a.35.35 0 00.282-.137l3.951-5.322c.094-.127-.003-.301-.169-.301z"
        fill="#253B80"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.398 10.725H37.93a.337.337 0 00-.338.27l-.999 5.907c-.02.116.077.221.203.221h1.267c.118 0 .219-.08.237-.19l.283-1.673a.336.336 0 01.339-.27h.78c1.627 0 2.566-.735 2.81-2.19.112-.636.005-1.137-.314-1.487-.35-.385-.973-.588-1.799-.588zm.285 2.157c-.135.827-.811.827-1.466.827h-.372l.262-1.544a.201.201 0 01.202-.162h.171c.446 0 .866 0 1.084.237.13.142.169.352.12.642zM47.776 12.856h-1.181a.2.2 0 00-.203.162l-.052.308-.083-.112c-.256-.346-.826-.462-1.396-.462a2.658 2.658 0 00-2.639 2.218c-.112.646.048 1.264.44 1.695.361.396.876.56 1.49.56 1.052 0 1.635-.63 1.635-.63l-.052.306c-.02.117.077.222.203.222h1.065a.337.337 0 00.338-.27l.64-3.776c.019-.116-.078-.221-.205-.221zm-1.647 2.146c-.114.63-.65 1.053-1.334 1.053-.342 0-.617-.102-.794-.297-.174-.193-.24-.468-.185-.775.107-.625.651-1.061 1.325-1.061.335 0 .608.104.788.3.18.198.252.475.2.78zM49.17 10.887l-1.013 6.014c-.02.117.077.222.203.222h1.018c.17 0 .313-.114.34-.27l.998-5.906c.02-.117-.077-.222-.203-.222h-1.14c-.1 0-.188.069-.203.162z"
        fill="#179BD7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.734 18.271l.189-1.119-.42-.009H6.495L7.89 8.887a.108.108 0 01.039-.065.119.119 0 01.074-.025h3.386c1.124 0 1.9.218 2.305.649.19.202.31.413.369.645.061.244.062.536.002.891l-.004.026v.228l.19.1c.16.08.287.17.384.274.163.172.268.392.312.652.046.268.03.586-.044.947a3.197 3.197 0 01-.416 1.072 2.271 2.271 0 01-.659.674 2.77 2.77 0 01-.887.373c-.327.08-.7.12-1.109.12h-.263a.834.834 0 00-.515.177.734.734 0 00-.269.447l-.02.1-.333 1.973-.015.072c-.004.023-.011.035-.021.042a.059.059 0 01-.035.012H8.734z"
        fill="#253B80"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.43 11.034c-.01.06-.021.122-.034.185-.447 2.14-1.974 2.878-3.925 2.878h-.993A.473.473 0 009 14.48l-.509 3.01-.144.852c-.024.145.095.275.251.275h1.762a.416.416 0 00.419-.334l.017-.083.332-1.965.021-.108a.416.416 0 01.419-.334h.263c1.707 0 3.043-.646 3.434-2.517.163-.782.079-1.435-.353-1.894a1.678 1.678 0 00-.482-.347z"
        fill="#179BD7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.963 10.86a3.696 3.696 0 00-.434-.09 5.91 5.91 0 00-.876-.06H10a.445.445 0 00-.183.04.399.399 0 00-.236.295l-.564 3.336L9 14.48a.473.473 0 01.477-.381h.994c1.95 0 3.478-.74 3.925-2.879.013-.063.024-.124.034-.185a2.485 2.485 0 00-.467-.174z"
        fill="#222D65"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.581 11.045a.398.398 0 01.236-.295.447.447 0 01.183-.039h2.653c.315 0 .608.02.876.06a4.141 4.141 0 01.434.09l.1.029c.132.04.255.089.368.144.133-.79-.001-1.328-.46-1.816-.504-.536-1.416-.766-2.582-.766H8.003a.475.475 0 00-.478.382l-1.41 8.34c-.028.166.109.314.287.314h2.09l.525-3.107.564-3.336z"
        fill="#253B80"
      />
    </svg>
  );
}

export default SvgPaypalColour;
